import ShButton from '@/components/Helpers/ShButton';

// @vue/component
export default {
  name: 'SmsIncomingSearchPanel',

  components: {
    ShButton,
  },

  props: {
  },

  data() {
    return {
      searchParams: {
        from_number: '',
        to_number: '',
        is_deleted: false,
      },
      statusList: [
        {
          label: 'wykonane',
          value: true,
        },
        {
          label: 'niewykonane',
          value: false,
        },
        {
          label: 'wszystkie',
          value: 'all',
        }
      ]
    };
  },

  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('changeFilterBy', newVal);
      },
      deep: true,
    },
  },

  methods: {
    clearSearchParams() {
      this.searchParams.from_number = '';
      this.searchParams.to_number = '';
      this.searchParams.is_deleted = false;
    }
  },
};
